import Api from "./Api";

export default {
  getAllMaintenanceList(payload) {
    let allMaintenanceList = Api().post(
      "Api_Maintenance/viewAllMaintenanceList.php",
      payload
    );
    return allMaintenanceList;
  },
  AddDataMaintenance(payload) {
    let AddMaintenanceData = Api().post(
      "Api_Maintenance/AddDataMaintenance.php",
      payload
    );
    return AddMaintenanceData;
  },
  EditDataMaintenance(payload) {
    let EditMaintenanceData = Api().post(
      "Api_Maintenance/EditDataMaintenance.php",
      payload
    );
    return EditMaintenanceData;
  },

  fetchToStockIn(payload) {
    let fetchToStockIn = Api().post(
      "Api_Maintenance/fetchToStockIn.php",
      payload
    );
    console.log("fetchToStockIn=>", fetchToStockIn)
    return fetchToStockIn;
  },
  AddItemForMaintenance(payload) {
    let AddItem = Api().post(
      "Api_Maintenance/addItem.php",
      payload
    );
    return AddItem;
  },
  getMaintenanceList(payload) {
    let data = Api().post(
      "Api_Maintenance/getMaintenance.php",
      payload
    );
    return data;
  },
};



// WEBPACK FOOTER //
// ./src/services/MaintenanceService.js